<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    getMe() {
      return this.$http
        .get(`${VUE_APP_API_HOST}/users/me`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    },

    updateUser(body) {
      const { id } = body
      delete body.id

      return this.$http
        .put(`${VUE_APP_API_HOST}/users/${id}`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    }
  }
}
</script>